<div class="provider-card">
    <div class="left-section">
        <div class="provider-image-container">
            <img [src]="provider.photoUrl || 'vudprovider.png'" alt="provider photo">
        </div>
    </div>
    <div class="right-section">
        <div class="provider-info-container">
            <div class="name">{{provider.providerName}}</div>
            <div class="specialty">{{provider.specialties}}</div>
        </div>
        <div class="bottom-section">
            <div *ngIf="provider.nextAvailability !== null || (provider.openScheduling != null && provider.openScheduling == true && provider.departmentId != null)" class="next-availability-container">
                <div *ngIf="waitTime != null && waitTime != ''" class="as-soon-as">{{soonAsText}}</div>
                <div class="next-availability">{{waitTime}}</div>
                <button class="primary-btn-web" (click)="onScheduleButtonClicked()">
                    <div>{{scheduleText}}</div>
                </button>
            </div>
            <div *ngIf="(provider.nextAvailability === null || (provider.openScheduling == null || provider.openScheduling != true || provider.departmentId == null)) && fromProviderSearch !== true" class="next-availability-container">
                <button class="primary-btn-web link" (click)="onViewDetails()">
                    <div>{{viewProfileBtnText}}</div>
                </button>
            </div>
        </div>
    </div>
</div>